import styled, { css } from 'styled-components'

import { Reset } from '@/lib/mixins'

export const KeyboardWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.5rem;
  width: 100%;
  max-width: 24rem;
  margin: 3rem auto;
`

export const KeyboardButton = styled.button<{ wide?: boolean }>`
  ${Reset('button')};
  position: relative;
  height: 4.5rem;
  border: 1px solid currentColor;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.75rem;
  font-weight: 400;
  position: relative;
  overflow: hidden;

  svg {
    height: 2.75rem;
    width: 2.75rem;
    fill: currentColor;
  }

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: currentColor;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.2s;
  }

  &:active::after,
  &:focus-visible::after {
    opacity: 0.05;
  }

  ${props =>
    props.wide &&
    css`
      grid-column: span 2;
    `};
`
